<section class="careers-section text-white py-5">
  <div class="container d-flex flex-column flex-lg-row align-items-center pt-4">
    <div class="row d-flex justify-content-between align-items-center pt-4">
      <div class="col-md-12 col-lg-6">
        <p class="text-blue mb-1">Job opportunities at Hilbertech</p>
        <h1 class="mb-1" style="color: #091b37">
          Be a Part of Hilbertech family
        </h1>
        <p style="color: #091b37; font-size: 20px">
          Join our dynamic team of skilled tech experts, working together on
          innovative projects for top companies. <br />Apply now at <a
            href="mailto:contact@hilbertech.com"
            class="text-blue fw-bold"
            >contact&#64;hilbertech.com</a
          >
        </p>
      </div>

      <div class="col-md-12 col-lg-6 text-center pe-0">
        <img
          src="/public/data/Green and Yellow Creative Charity Video 1.svg"
          alt="Careers at Hilbertech"
          class="careers-img img-fluid animate__animated zoom-hover"
        />
      </div>
    </div>
  </div>
</section>
<!-- Job Openings -->
<section class="bg-darkblue">
  <section class="top-section text-center text-md-start">
    <div
      class="py-5 d-flex flex-column gap-3 justify-content-between align-items-center"
    >
      <img src="/public/logo/briefcase.svg" alt="briefcase" />
      <p class="fw-bold" style="color: #091b37; font-size: 32px">
        We’re not hiring at the moment.
      </p>
      <!-- <p style="color: #091b37; font-size: 32px">
        But we’re always looking for talented people.
      </p>
      <button class="Submit-btn" (click)="isOpened = true">
        Submit Application
      </button> -->
    </div>
    <!-- <div class="container">
      <div class="row justify-content-between align-items-center">
        <div class="col-md-6">
          <h1>Current Openings</h1>
          <p>
            If you're inspired by our work and think you could be a great fit
            for our team
          </p>
        </div>
        <div class="col-md-6">
          <div class="job-listing mt-4">
            <a href="#" class="shadow-sm icon-link icon-link-hover">
              <div>
                <strong>Senior Data Engineer</strong><br />
                <small>Remote, Full Time</small>
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="bi fs-3"
                viewBox="0 0 16 16"
                aria-hidden="true"
              >
                <path
                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                />
              </svg>
            </a>
            <a href="#" class="shadow-sm icon-link icon-link-hover">
              <div>
                <strong>Project Manager</strong><br />
                <small>Remote, Part Time</small>
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="bi fs-3"
                viewBox="0 0 16 16"
                aria-hidden="true"
              >
                <path
                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div> -->
  </section>

  <!-- Benefits -->
  <section class="benefits-section mx-5">
    <div class="container">
      <h3 class="mb-5 text-center">
        Benefits Of Being Part Of The Hilbertech Team
      </h3>
      <div class="row g-4 text-start">
        <div class="col-md-4">
          <div class="benefit-box bg-green">
            <img src="/public/icons/icon1.svg" alt="Remote Work" />
            <h5>Remote Work Model</h5>
            <p>
              Our company offers a flexible remote work model designed to
              empower you to work from anywhere.
            </p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="benefit-box bg-grey">
            <img src="/public/icons/icon2.svg" alt="Flexible Timing" />
            <h5>Flexible Timing</h5>
            <p>
              We empower employees to work on their strengths and adjust to
              their working hours.
            </p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="benefit-box bg-blue">
            <img src="/public/icons/icon3.svg" alt="Training" />
            <h5>Training Sessions</h5>
            <p>
              Practical training and learning sessions from mentors and industry
              experts.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Testimonials -->
  <section class="testimonials-section bg-darkblue text-white py-5">
    <div class="container">
      <h2 class="section-title">Here Is What Our Team Says</h2>

      <div class="row">
        <!-- Testimonial 1 -->
        <div class="col-md-6 mb-3">
          <div class="testimonial-box">
            <p>
              Hilbertech is a fantastic company to work for if you want to build
              a long-term career. It is one of the most reliable, stable, and
              fastest-growing companies. Hilbertech is an equal opportunity
              company that offers opportunities to employees at all stages of
              their careers, from entry-level to mid-level.
            </p>
            <div class="quote-footer footer-blue top-100">
              <div>
                <div class="footer-name">Ahmed Gamal</div>
                <span>Full Stack Developer</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Testimonial 2 -->
        <div class="col-md-6 offset-md-6 mb-3">
          <div class="testimonial-box">
            <p>
              It’s been an amazing journey. At Hilbertech, everyone gets a fair
              and equal chance to perform. It has an open culture to learn and
              grow. You can always look for a promising career graph at
              Hilbertech. Great place, good colleagues, supportive management,
              friendly policies, a perfect combination of a dream job.
            </p>
            <div class="quote-footer footer-teal top-100">
              <div>
                <div class="footer-name">Hesham Shawky</div>
                <span>Full Stack Developer</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Testimonial 3 -->
        <div class="col-md-6 mb-3">
          <div class="testimonial-box">
            <p>
              Hilbertech is an amazing organization with a supportive work
              culture that accelerates career growth.
            </p>
            <div class="quote-footer footer-pink top-100">
              <div>
                <div class="footer-name">Samar Ali</div>
                <span>Front End Developer</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</section>

@if(isOpened){
<app-submit-application (close)="isOpened = false" />
}
